import React from 'react';
import { formatCurrency } from 'utils/formatCurrency';
import { Link } from 'react-router-dom';
import type { TicketListItem } from 'types/models';

interface TicketItemProps {
  ticket: TicketListItem;
}

const TicketItem = ({ ticket }: TicketItemProps) => {
  return (
    <Link
      to={`/ticketDetailV2/${ticket.billId}`}
      className='tickets-item mb-3 border rounded overflow-hidden'
    >
      <div className='tickets-header d-flex justify-content-between align-items-center p-3 bg-white'>
        <div className='tickets-id-container d-flex align-items-center'>
          <div className='tickets-id bg-dark text-white p-2 rounded'>
            #{ticket.id}
          </div>
          <div className='tickets-customer ml-3'>
            <span className='tickets-customer-label'>Customer: </span>
            <span className='tickets-customer-name font-weight-bold'>
              {ticket.customer}
            </span>
          </div>
        </div>
        <div>

        <div className='tickets-date text-muted'>{ticket.date}</div>
        <div className='tickets-date text-muted'>{ticket.time}</div>
        </div>
      </div>

      <div className='tickets-total p-3 border-top border-bottom bg-white'>
        <span className='tickets-total-label text-primary font-weight-bold'>
          TOTAL:{' '}
        </span>
        <span className='tickets-total-amount text-primary font-weight-bold'>
          {formatCurrency(ticket.total)}
        </span>
      </div>
    </Link>
  );
};

export default TicketItem;
